import React, { useContext } from "react";
import { StoreContext } from "../context/Store";
import InputFile from "../parts/InputFile";
import Text from "../parts/Text";

export interface PhotoProps {}

export interface PhotoState {}

export const Photo = (props: PhotoProps) => {
  const store = useContext(StoreContext);
  const onPhotoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      console.log(e.target.files[0]);
      store.setUserImage(e.target.files[0]);
    }
  };

  return (
    <section id="photo" className="mb-5">
      <Text tag="h4" color="blue" classes="mb-2">
        Zdjęcie to kolejny ważny element CV.
      </Text>
      <Text tag="p" classes="mb-5">
        Warto je dodać, bo będziesz bardziej realny. Najlepiej, jeśli będzie to
        Twój aktualny, uśmiechnięty portret.
      </Text>
      <InputFile
        name="photo"
        label="wstaw zdjęcie >>"
        onChange={onPhotoChange}
      />
    </section>
  );
};

export default Photo;
